import { render, staticRenderFns } from "./ProjectEditExtraOptionBudgetsTab.vue?vue&type=template&id=6092058a"
import script from "./ProjectEditExtraOptionBudgetsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditExtraOptionBudgetsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports